import style from "./grid\.module.css";

function Grid(props) {
  return <div className={`${style[`grid${props.no}`]}`}>
    {props.children}
  </div>;
}
export default Grid;
